const getMeasurementUnit = (measurementUnit) => {
  switch (measurementUnit) {
    case "LITER":
      return "л.";
    case "MILLILITER":
      return "мл.";
    default:
      return "гр.";
  }
};

export default getMeasurementUnit;
